export const roundUp = (n) => Math.ceil(n);

export function formatDate(d) {
  return d.format("DD/MM/YYYY");
}

export function safeNumber(value) {
  if (typeof value === "string") return Number(value.replace(/\./g, ""));
  return Number(value ?? 0);
}

export function mergeWithExistingPayments(newSchedule, scheduleWithPayments) {
  return newSchedule.map((cuota) => {
    const original = scheduleWithPayments.find(
      (p) => p.cuota === cuota.cuota && p.paymentInfo // 👈 SOLO pagos del deudor
    );

    return original
      ? {
          ...cuota,
          cuotaAPagar: original.paymentInfo.amount, // respetar amount original
          payment: original.payment, // respetar si ya fue pagada
          paymentInfo: original.paymentInfo, // mantener datos del pago
        }
      : cuota;
  });
}
